import { FormSectionGroup } from '@vwfs-bronson/bronson-react';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { AddressFormNew } from '../../../../components/AddressFormNew';
import { BankDetailsNew } from '../../../../components/BankDetailsNew';
import { ContactDetailsFormNew } from '../../../../components/ContactDetailsFormNew';
import { PersonalDetailsFormNew } from '../../../../components/PersonalDetailsFormNew';
import { TradingDetailsServicePlanBusinessFormNew } from '../../../../components/TradingDetailsServicePlanBusinessFormNew';
import { journeyDataSelectors } from '../../../../services/redux/features/journeyData.slice';
import { useFormSectionHelpers } from '../../../utils';

const getCustomerFormsToRender = (
  showBankDetails: boolean,
  showPartner1Details: boolean,
  showPartner2Details: boolean
) => {
  return [
    'partnershipDetails',
    'contactAddress',
    'contactDetails',
    ...(showBankDetails ? (['partnershipBankAccountDetails'] as const) : []),
    ...(showPartner1Details ? (['partner1Details'] as const) : []),
    ...(showPartner2Details ? (['partner2Details'] as const) : []),
  ] as const;
};

type FormId = ReturnType<typeof getCustomerFormsToRender>[number];

export const CustomerDataServicePlanBusinessLtdPlc = () => {
  const [forms, setForms] = useState<ReadonlyArray<FormId>>(() => getCustomerFormsToRender(false, false, false));
  const [isFirstPersonAdded] = useState(false);
  const [isSecondPersonAdded] = useState(false);

  // When in Standalone Service Plan user selected Upfront payment for service plan,
  // then we do not need Bank Details

  const isUpfrontPayment = useSelector(journeyDataSelectors.isUpfrontPayment);

  const showBankDetails = !isUpfrontPayment;
  const showPartner1Details = isFirstPersonAdded;
  const showPartner2Details = isSecondPersonAdded;

  const getFormHelpers = useFormSectionHelpers(forms);

  useEffect(() => {
    setForms([...getCustomerFormsToRender(showBankDetails, showPartner1Details, showPartner2Details)]);
  }, [showBankDetails, showPartner1Details, showPartner2Details]);

  return (
    <>
      <FormSectionGroup>
        <TradingDetailsServicePlanBusinessFormNew.SPB formHelpers={getFormHelpers('partnershipDetails')} />
        <AddressFormNew.SPB formHelpers={getFormHelpers('contactAddress')} />
        <ContactDetailsFormNew.SPB formHelpers={getFormHelpers('contactDetails')} />

        {!isUpfrontPayment && (
          <BankDetailsNew.SPB
            formHelpers={getFormHelpers('partnershipBankAccountDetails')}
            titleTranslationKey="bankDetailsForm:title:business"
          />
        )}

        {/* Feature hidden in PC-3382 */}
        {/* <Layout className="u-mb">
          <Layout.Item>
            <Button
              icon={isFirstPersonAdded ? 'semantic-minus' : 'semantic-plus'}
              link
              secondary
              onClick={() => actions.customerDataServicePlanBusinessLtdPlc.setIsFirstPersonAdded(!isFirstPersonAdded)}
            >
              {isFirstPersonAdded
                ? t('customerDataServicePlanBusinessLtdPlc:removePartner1')
                : t('customerDataServicePlanBusinessLtdPlc:addPartner1')}
            </Button>
          </Layout.Item>
        </Layout> */}

        {isFirstPersonAdded && (
          <PersonalDetailsFormNew.SPB
            formHelpers={getFormHelpers('partner1Details')}
            titleTranslationKey="personalDetailsForm:title:mixed1"
          />
        )}

        {/* Feature hidden in PC-3382 */}
        {/* <Layout className="u-mb">
          <Layout.Item>
            <Button
              icon={isSecondPersonAdded ? 'semantic-minus' : 'semantic-plus'}
              link
              secondary
              onClick={() => actions.customerDataServicePlanBusinessLtdPlc.setIsSecondPersonAdded(!isSecondPersonAdded)}
            >
              {isSecondPersonAdded
                ? t('customerDataServicePlanBusinessLtdPlc:removePartner2')
                : t('customerDataServicePlanBusinessLtdPlc:addPartner2')}
            </Button>
          </Layout.Item>
        </Layout> */}

        {isSecondPersonAdded && (
          <PersonalDetailsFormNew.SPB
            formHelpers={getFormHelpers('partner2Details')}
            titleTranslationKey="personalDetailsForm:title:mixed2"
          />
        )}
      </FormSectionGroup>
    </>
  );
};
